<template>
  <div class="exchange-pay"></div>
</template>
<script>
import _wx from "../../static/js/chelun-wx-1.1.js";
import URL from "../../static/js/url.js";
import { exchangePay } from "@/http/api";
import { encrypt } from "@/util/md5";
import { Toast } from "mint-ui";

export default {
  data() {
    return {
      openid: "",
      public_path: process.env.PUBLICK_PATH,
      pay_id: "",
    };
  },
  created() {
    this.openid = URL.getQueryString("openid");
    this.pay_id = URL.getQueryString("pay_id");
    this.payHandle();
    window["CHELUN_SHOW_OPTION_MENU"] = 0;
    _wx.hideMenus([
      "menuItem:share:appMessage",
      "menuItem:share:timeline",
      "menuItem:share:qq",
      "menuItem:share:weiboApp",
      "menuItem:favorite",
      "menuItem:share:facebook",
      "menuItem:share:QZone",
    ]);
  },
  methods: {
    payHandle() {
      let data = {
        open_id: this.openid,
        exchange_id: this.pay_id,
        pay_type: 0, // 微信 0  支付宝 1
      };
      exchangePay(data).then((res) => {
        this.onBridgeReady(res.data);
      });
    },

    onBridgeReady(data) {
      let _this = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: data.appId, //公众号ID，由商户传入
          timeStamp: data.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: data.nonceStr, //随机串
          package: data.package,
          signType: "RSA", //微信签名方式：
          paySign: data.paySign, //微信签名
        },
        function (res) {
          console.log(res, "======================>>>res");
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            window.location.href = `${window.$root.$requestEnv.hostUrl}/h5/exchange-detail`;
          } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
            Toast("用户取消支付");
            _this.$router.go(-1);
          } else if (res.err_msg === "get_brand_wcpay_request:fail") {
            Toast("网络异常，请重试");
            _this.$router.go(-1);
          } else {
            Toast({
              message: "支付失败",
              position: "center",
              duration: 1500,
            });
            _this.$router.go(-1);
          }
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/exchange-pay.vue